import { useEffect, useState } from "react";
import throttle from "lodash/throttle";
import { waitForElementToLoad } from "@shared/services/loaders/element-loader";
import { domElementIds } from "@shared/constants/common";

const { navbarId, headerTabsId } = domElementIds;

/**
 * Calculates the offset needed for the detail page navbar to not cover the components being scrolled to.
 * To use, call this hook and apply the value to scrollMarginTop on Chakra UI components.
 *
 * Example:
 * const scrollMargin = useDetailPageScrollMargin();
 * <Box scrollMarginTop={scrollMargin} />
 */
const useDetailPageScrollMargin = () => {
  const [scrollMarginTop, setScrollMarginTop] = useState(0);

  // get the height of any navbar banners that are currently displayed
  // set the top of the tab component based on the retrieved height
  const handleScrollMarginTop = () => {
    const tabHeight = document?.getElementById(headerTabsId)?.scrollHeight ?? 0;

    setScrollMarginTop(tabHeight + 20);
  };

  // handle tab height based on initial load and resize events
  useEffect(() => {
    waitForElementToLoad(`#${navbarId}`).then(() => {
      waitForElementToLoad(`#${headerTabsId}`).then(() => {
        handleScrollMarginTop();
        let handleResizeDelay;

        // add delay to function call so that we get the tab height display at the end of the resize event
        window.addEventListener("resize", () => {
          clearTimeout(handleResizeDelay);
          handleResizeDelay = setTimeout(
            throttle(() => {
              handleScrollMarginTop();
            }, 250),
            100
          );
        });
      });
    });
  }, []);

  return scrollMarginTop;
};

export default useDetailPageScrollMargin;
